<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
 @import "./common/font/font.css";
  ul,ol{ list-style: none;}
  input{ outline:none}
  img{ display: block; border:0;}
  header,footer,nav,main,article,aside,section{ display:block;}
  a{ text-decoration: none;}
  html, body{font-size:12px;}
  body,h1,h2,h3,h4,h5,h6,ol,ul,li,dl,dt,p,dd,input,img,a,figure,figcaption{padding:0; margin:0;}
  button{outline:none;cursor:pointer;}
 .cursor{
   cursor: pointer;
  }
  .main_page{
	  min-width: 1024px;
	  margin: 0 auto;
	  min-height: 60px;
  }
  .hr_red{
	width:70px;
	height: 4px;
  	background-color: #E91926 !important;
	border: 0;
	display: flex;
  }
  .index-div2 .index-div2-li .el-carousel__container{
	  height:480px;
	  overflow: hidden;
	}
	.index-div2 .index-div2-li .el-carousel__arrow {
		height: 130px;
		width: 34px;
		font-size:42px;
		background-color: unset;
	}
	.index-div2 .index-div2-li .el-carousel__arrow:hover{
		background-color: unset;
	}
	.index-div2 .index-div2-li .el-carousel{
		height: 510px;
	}
	.index-div2 .index-div2-li:nth-child(2) .el-carousel__arrow{
		color:#323232
	}
	.distance_top_20{
		margin-top:20px;
	}
	.distance_top_30{
		margin-top:30px !important;
	}
	.distance_top_40{
		margin-top:40px;
	}
	.distance_top_50{
		margin-top:50px;
	}
	.el-dialog{
		box-shadow:unset !important;
	}
	.home_dialog_page .el-dialog__body{
		padding:0;
	}
	.home_dialog_page .el-dialog__header{
		padding-top:0;
	}
	.home_dialog_page .el-dialog{
		width:360px !important;
		margin-top:30px !important;
	}
	.home_dialog_page .el-dialog, .el-pager li{
		background: unset !important;
	}
	.home_dialog_page .el-form-item{
		margin-bottom:10px !important;
	}
	.home_dialog_page .el-form-item__content{
		margin-left: 0 !important;
	}
	.home_dialog_page  .el-input{
		width:260px !important;
		height:30px !important;
		margin-left:50px !important;
	}
	.home_dialog_page  .el-input .el-input__inner{
		height:30px !important;
		border-radius:20px !important;
	}
	.home_dialog_page .el-checkbox-group{
		width:220px !important;
		height:10px !important;
		margin-left:70px !important;
	}
	.home_dialog_page .el-checkbox{
		height:30px !important;
	}
	.el-checkbox__inner{
		border-radius: 50%;
		/* width:10px !important;
		height: 10px !important; */
	}
	.home_dialog_page .el-checkbox__label{
		font-size:11px !important;
		color:#E8E6E6 !important;
	}
	.el-checkbox__label{
		color:#E8E6E6 !important;
	}
	.buyPro_main .buyPro_right .pay_content  .pay_mode .el-radio__input{
		display: block ;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue